import { useSchemaModules } from "./useSchemaModules";

export function useModuleEnabled(name) {
    const modules = useSchemaModules();
    return modules.includes(name);
}
